import '@testing-library/jest-dom';
import { render, screen, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { ActionList } from './ActionList';

const onClickSpy = jest.fn();

const BUTTON_LIST = [
  <button key="1" type="button" onClick={onClickSpy}>
    Test Action 1
  </button>,
  <button key="2" type="button">
    Test Action 2
  </button>,
  <button key="3" type="button">
    Test Action 3
  </button>,
];

describe('ActionList', () => {
  it('should render (variant primary)', () => {
    render(
      <ActionList label="Test ActionList" variant="primary" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    expect(screen.getByText('Test ActionList')).toBeInTheDocument();
    expect(screen.getByText('Test ActionList')).toHaveClass('button--primary');
    expect(screen.getByText('Test Action 1')).toBeInTheDocument();
    expect(screen.getByText('Test Action 2')).toBeInTheDocument();
    expect(screen.getByText('Test Action 3')).toBeInTheDocument();
  });

  it('should render variant secondary', () => {
    render(
      <ActionList label="Test ActionList" variant="secondary" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    expect(screen.getByText('Test ActionList')).toBeInTheDocument();
    expect(screen.getByText('Test ActionList')).toHaveClass('button--secondary');
  });

  it('should render variant destructive-primary', () => {
    render(
      <ActionList label="Test ActionList" variant="destructive-primary" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    expect(screen.getByText('Test ActionList')).toBeInTheDocument();
    expect(screen.getByText('Test ActionList')).toHaveClass('button--destructive-primary');
  });

  it('should render variant destructive-secondary', () => {
    render(
      <ActionList label="Test ActionList" variant="destructive-secondary" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    expect(screen.getByText('Test ActionList')).toBeInTheDocument();
    expect(screen.getByText('Test ActionList')).toHaveClass('button--destructive-secondary');
  });

  it('should render variant blank', () => {
    render(
      <ActionList label="Test ActionList" variant="blank" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    expect(screen.getByText('Test ActionList')).toBeInTheDocument();
    expect(screen.getByText('Test ActionList')).toHaveClass('button--blank');
  });

  it('should render variant blank-icon', () => {
    render(
      <ActionList label="Test ActionList" variant="blank-icon" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    expect(screen.getByText('Test ActionList')).toBeInTheDocument();
    expect(screen.getByText('Test ActionList')).toHaveClass('button--blank-icon');
  });

  it('should toggle content visibility on click', async () => {
    render(
      <ActionList label="Test ActionList" variant="blank-icon" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    const triggerElement = screen.getByText('Test ActionList');
    const actionListElement = screen.getByRole('menu');
    expect(triggerElement).toBeInTheDocument();
    expect(actionListElement).toBeInTheDocument();
    await userEvent.click(triggerElement);
    await waitFor(() => {
      expect(actionListElement).toHaveClass('action-list--open');
    });
    await userEvent.click(triggerElement);
    await waitFor(() => {
      expect(actionListElement).not.toHaveClass('action-list--open');
    });
  });

  it('should fire action on click on action button', async () => {
    render(
      <ActionList label="Test ActionList" variant="blank-icon" iconName="EllipsisVertical">
        {BUTTON_LIST.map((button) => button)}
      </ActionList>
    );
    const triggerElement = screen.getByText('Test ActionList');
    const actionListElement = screen.getByRole('menu');
    expect(triggerElement).toBeInTheDocument();
    expect(actionListElement).toBeInTheDocument();
    await userEvent.click(triggerElement);
    await waitFor(() => {
      expect(actionListElement).toHaveClass('action-list--open');
    });
    const actionButton = screen.getByText('Test Action 1');
    await userEvent.click(actionButton);
    expect(onClickSpy).toHaveBeenCalledTimes(1);
    await waitFor(() => {
      expect(actionListElement).not.toHaveClass('action-list--open');
    });
  });
});
